import React from "react"

function AudioFile(props) {
    return (
        <div>
            <audio className="audios" id={props.name}> 
                <source src={props.audioSource} type="audio/mp3" />
            </audio>
        </div>
    )
}

export default AudioFile